import { NavLink } from "react-router-dom";
import {
  Bell,
  Home,
  type LucideIcon,
  MessageCircle,
  User,
  Users,
  Star,
  Search,
} from "lucide-react";
import { useSchoolNewsDot, useSchoolNewsEnabled } from "@/hooks/useSchoolNewsEnabled";

interface TabItem {
  label: string;
  to: string;
  icon?: LucideIcon;
  coach?: boolean;
  end?: boolean;
}

interface BottomTabBarProps {
  userType?: "player" | "coach";
}

const BottomTabBar = ({ userType }: BottomTabBarProps) => {
  const schoolNewsEnabled = useSchoolNewsEnabled();
  const schoolNewsDot = useSchoolNewsDot();
  const tabs: TabItem[] = [
    { label: "My Schools", to: "/pipeline", icon: Star },
    ...(userType === "coach" ? [{ label: "Home", to: "/", icon: Home, end: true }] : []),
    { label: "Ask Coach", to: "/chat", coach: true },
    { label: "School Search", to: "/schools", icon: Search },
    ...(schoolNewsEnabled ? [{ label: "Notifications", to: "/notifications", icon: Bell }] : []),
    { label: "Profile", to: "/profile", icon: User },
    ...(userType === "coach" ? [{ label: "Coach's Corner", to: "/coach", icon: Users }] : []),
  ];
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-20 bg-card border-t border-border pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center justify-around h-14">
        {tabs.map(({ label, to, icon: Icon, coach, end }) => {
          const dot = to === "/notifications" && schoolNewsDot;
          return (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                [
                  "flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors",
                  isActive ? "text-primary-text" : "text-muted-foreground hover:text-foreground",
                ].join(" ")
              }
              aria-label={dot ? `${label}, new updates` : label}
            >
              <span className="relative">
                {coach ? (
                  <MessageCircle className="h-5 w-5" strokeWidth={2} />
                ) : (
                  Icon && <Icon className="h-5 w-5" strokeWidth={2} />
                )}
                {dot && (
                  <span
                    data-testid="notifications-dot"
                    aria-hidden="true"
                    className="absolute -right-1 -top-0.5 h-2 w-2 rounded-full bg-primary ring-2 ring-card"
                  />
                )}
              </span>
              <span className="text-[11px] font-medium leading-tight">{label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomTabBar;
